module.exports = __webpack_public_path__ + "img/style1.fe03df19.png";